var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnsys(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ansys_logo",
    "data-name": "Ansys logo",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: 207.209,
    height: 65.5,
    viewBox: "0 0 207.209 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ansys Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12755",
    "data-name": "Path 12755",
    d: "M1282.419,187.015l-21.79,51.76h14.879l20.98-51.76Z",
    transform: "translate(-1260.629 -187.015)",
    fill: "#ffb71b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12756",
    "data-name": "Path 12756",
    d: "M1318.864,196.986q3.118,3.777,3.12,11.4V230.1h-10.955V208.9q0-3.669-1.341-5.354a5.005,5.005,0,0,0-4.172-1.688,7.157,7.157,0,0,0-5.476,2.2,8.208,8.208,0,0,0-2.07,5.867V230.1h-10.953V194.09h10.662v5.133a12.506,12.506,0,0,1,4.9-4.471,14.652,14.652,0,0,1,6.78-1.541q6.385,0,9.505,3.775",
    transform: "translate(-1224.172 -178.295)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12757",
    "data-name": "Path 12757",
    d: "M1310.85,229.546a22.192,22.192,0,0,1-7.074-3.264l2.9-7.627a24.215,24.215,0,0,0,6.385,3.081,23.283,23.283,0,0,0,7.038,1.1,7.741,7.741,0,0,0,3.953-.845,2.584,2.584,0,0,0,1.414-2.309,2.415,2.415,0,0,0-.981-2.053,10.3,10.3,0,0,0-3.663-1.319l-5.8-1.322q-5.152-1.17-7.581-3.628a9.132,9.132,0,0,1-2.429-6.712,9.644,9.644,0,0,1,1.922-5.939,12.71,12.71,0,0,1,5.439-4.032,20.689,20.689,0,0,1,8.019-1.466,24.208,24.208,0,0,1,7.471,1.172,22.911,22.911,0,0,1,6.528,3.3l-2.9,7.331a19.475,19.475,0,0,0-11.174-3.958,7.676,7.676,0,0,0-3.989.881,2.762,2.762,0,0,0-1.448,2.492,2.174,2.174,0,0,0,.867,1.834,9.425,9.425,0,0,0,3.048,1.245l6.021,1.394q5.445,1.246,7.943,3.777a9.32,9.32,0,0,1,2.505,6.856,9.55,9.55,0,0,1-4.1,8.176q-4.1,2.972-11.282,2.971a33.716,33.716,0,0,1-9.031-1.136",
    transform: "translate(-1201.016 -178.295)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12758",
    "data-name": "Path 12758",
    d: "M1341.487,229.546a22.211,22.211,0,0,1-7.073-3.264l2.9-7.627a24.163,24.163,0,0,0,6.383,3.081,23.272,23.272,0,0,0,7.035,1.1,7.738,7.738,0,0,0,3.956-.845,2.578,2.578,0,0,0,1.412-2.309,2.414,2.414,0,0,0-.979-2.053,10.294,10.294,0,0,0-3.663-1.319l-5.8-1.322q-5.155-1.17-7.578-3.628a9.124,9.124,0,0,1-2.431-6.712,9.646,9.646,0,0,1,1.922-5.939,12.706,12.706,0,0,1,5.442-4.032,20.675,20.675,0,0,1,8.014-1.466,24.192,24.192,0,0,1,7.474,1.172,22.85,22.85,0,0,1,6.528,3.3l-2.9,7.331a19.469,19.469,0,0,0-11.172-3.958,7.691,7.691,0,0,0-3.991.881,2.764,2.764,0,0,0-1.451,2.492,2.172,2.172,0,0,0,.872,1.834,9.406,9.406,0,0,0,3.046,1.245l6.023,1.394q5.438,1.246,7.943,3.777a9.329,9.329,0,0,1,2.5,6.856,9.546,9.546,0,0,1-4.1,8.176q-4.1,2.972-11.28,2.971a33.7,33.7,0,0,1-9.033-1.136",
    transform: "translate(-1158.689 -178.295)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12759",
    "data-name": "Path 12759",
    d: "M1280.838,187.693l-7.052,17.4,13.267,32.732h14.889Z",
    transform: "translate(-1242.451 -186.061)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M7.982,49.162,19.7,21.316,14.337,34.062,0,0H10.81l8.934,21.22L28.678,0H39.486L18.793,49.162Z",
    transform: "translate(136.01 15.838)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnsys);
export default __webpack_public_path__ + "static/media/ansys.58eb4fd09be7b0fe947a4a0927f33f97.svg";
export { ForwardRef as ReactComponent };